<template>
  <div id="app" class="App">
    <div style="display:none">Version 2.1.0</div>
    <a class="skip-main" href="#main">Skip to main content</a>
    <nav class="navbar navbar-default navbar-fixed-top my-navbar">
      <div class="container">
        <div class="navbar-header">
          <div style="display: flex;justify-content: space-between;">
            <div>
              <a :href="$root.languageData.APP && $root.languageData.APP.logoLink" class="aClass" target="_blank">
                <img src="@A/images/HKMA.png" :alt="$root.languageData.APP && $root.languageData.APP.content.preview[5]" class="logo maximg">
              </a>
            </div>
            <div style="margin-top: auto; margin-bottom: auto;">
              <button class="aClass menuIconButton" target="_self" @click="opcl">
                <img src="@A/images/menu.png" :alt="$root.languageData.APP && $root.languageData.APP.content.preview[12]" class="logo menuIcon">
            </button>
            </div>
          </div>
        </div>

        <div class="collapse navbar-collapse navbar-right" :class="{vrvr: opc == true}" id="top-nav">
          <ul class="nav navbar-nav language-wrap">
            <li>
              <button class="del-btn-style" @click="changeLanguage(1)" v-bind:class="{'lan-style':isLanSelect==1}" title="ENGLISH">ENG</button> |
              <button class="del-btn-style" @click="changeLanguage(2)" v-bind:class="{'lan-style':isLanSelect==2}" title="繁體">繁</button> |
              <button class="del-btn-style" @click="changeLanguage(3)" v-bind:class="{'lan-style':isLanSelect==3}" title="简体">简</button>
              <span>&nbsp;</span>
              <span>&nbsp;</span>
              <button @click="changeFontSize(0)" v-bind:class="{'font-style':isFontSelect==0}" class="smallFont common-style" :title="$root.languageData.APP && $root.languageData.APP.tiptitle[0]">A</button>
              <button @click="changeFontSize(1)" v-bind:class="{'font-style':isFontSelect==1}" class="midFont common-style" :title="$root.languageData.APP && $root.languageData.APP.tiptitle[1]">A</button>
              <button @click="changeFontSize(2)" v-bind:class="{'font-style':isFontSelect==2}" class="bigFont common-style" :title="$root.languageData.APP && $root.languageData.APP.tiptitle[2]">A</button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div :class="{longlong: opc == true}">

    </div>
    <div class="router-container row" :class="mode?'color-b':''" :inert="opc && windowWidth <768 && ieNum != ''">
      <h1 class="router-title fs" v-if="ifTitle" id="main">
        {{title}}
      </h1>
      <div v-if="!opc" style="margin-left: auto; margin-right: auto;" class="mainContentContainer">
        <div v-if="ieNum==9.0" class="router col-xs-12 col-sm-12 col-md-12" :style="ifTitle?'margin-top: 0;': ''">
          <router-view></router-view>
        </div>
        <div v-else class="router1 col-xs-12 col-sm-12 col-md-12" :style="ifTitle?'margin-top: 0;': ''">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import simple from '@L/simple'
import complex from '@L/complex'
import English from '@L/English'
export default {
  name: 'App',
  data () {
    return {
      ieNum: '',
      Language: '', // 語言模式
      mode: 0, // 0 普通模式 1 色盲模式
      ifTitle: false, // 是否有標題
      title: '',
      isFontSelect:0, //字號顯示
      isLanSelect:1, //語言顯示
      opc: false,
      a: false,
      windowWidth: window.innerWidth

    }
  },
  methods: {
    getUrl(url,name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = url.split("?")[1].match(reg);
        //    var r = url.split(name+"=")[1].split("!")[0];
        if (r != null)
            return decodeURI(r[2]);
        return null;
    },
    opcl() {
      this.opc = !this.opc;
    },
    changeT(){
      if(window.location.hash=='#/'){
        document.title = this.$root.languageData.APP.title
      }else if(window.location.hash=='#/note'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.pTitle[5]
      }else if(window.location.hash=='#/home'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.pTitle[6]
      }else if(window.location.hash=='#/part1'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.pTitle[0]
      }else if(window.location.hash=='#/part2'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.pTitle[1]
      }else if(window.location.hash=='#/part3'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.pTitle[2]
      }else if(window.location.hash=='#/part4'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.pTitle[4]
      }else if(window.location.hash=='#/preview'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.content.preview[0]
      }else if(window.location.hash==this.sessionGetItem('formId')){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.content.submit[0]
      }else if(window.location.hash=='#/wrongPage'){
        document.title = this.$root.languageData.APP.title + ' - ' + this.$root.languageData.APP.pTitle[7]
      }
    },
    changeUrl(url){
      if(window.location.hash=='#/'||window.location.hash=='#/?lang=en'||window.location.hash=='#/?lang=tc'||window.location.hash=='#/?lang=sc'){
        this.$toPage('/?lang='+url)
      }
    },
    fontSelect(){
      var obj = document.getElementById("sizeSelect");
      var value = obj.options[obj.selectedIndex].value; // 选中值
      this.changeFontSize (value)
    },
    changeFontSize (size) {
      this.isFontSelect = size;
      console.log(this.isFontSelect);
      window.document.documentElement.setAttribute('data-size', size)
    },
    changeMode (mode) {
      this.mode = mode
    },
    changeLanguage (lang) {
      this.isLanSelect = lang;
      this.sessionSetItem('Language', lang)
      this.Language = this.sessionGetItem('Language')
      if (this.Language === '1') {
        this.$root.languageData = English
        this.changeT()
        if(window.location.href.indexOf('?lang=') >=1){
          this.changeUrl('en')
        }
      } else if (this.Language === '2') {
        this.$root.languageData = complex
        this.changeT()
        if(window.location.href.indexOf('?lang=') >=1){
          this.changeUrl('tc')
        }
      } else if (this.Language === '3') {
        this.$root.languageData = simple
        this.changeT()
        if(window.location.href.indexOf('?lang=') >=1){
          this.changeUrl('sc')
        }
      }
      this.titleChange()
    },
    titleChange () {
      //获取当前元素
      var appEle = document.getElementById("app");
      //获取父级标签
      var indexHtml = appEle.parentNode.parentNode;
      // console.log(indexHtml);
      var lang = indexHtml.lang;

      this.ifTitle = this.$root.$route.meta.ifTitle || false
      if (this.Language === '1') {
        this.title = this.$root.$route.meta.titleEnglish
        indexHtml.lang = "zh-Hant";
      } else if (this.Language === '2') {
        this.title = this.$root.$route.meta.titleComplex
        indexHtml.lang = "zh-Hant";
      } else if (this.Language === '3') {
        this.title = this.$root.$route.meta.titleSimple
        indexHtml.lang = "zh-Hant";
      }
      // this.$forceUpdate()
    },
    onResize() {
      this.windowHeight = window.innerHeight
      console.log(`window.innerHeight ${window.innerHeight}`)
    }
  },
  created () {
  },
  watch: {
		'$route' (to, from) { //监听路由是否变化
      console.log(`Current Path Details: `)
      console.log(to)
      console.log(`URL path ${window.location.href}`);
      if(window.location.href.indexOf('?lang=') >=1){
        console.log(this.getUrl(window.location.href,'lang'));
        if(this.getUrl(window.location.href,'lang')=='en'){
          this.sessionSetItem('Language', 1)
        }else if(this.getUrl(window.location.href,'lang')=='tc'){
          this.sessionSetItem('Language', 2)
        }else if(this.getUrl(window.location.href,'lang')=='sc'){
          this.sessionSetItem('Language', 3)
        }
      }
      if(!this.sessionGetItem('Language')){
        this.sessionSetItem('Language', 1)
      }
      this.Language = this.sessionGetItem('Language')
      this.isLanSelect = this.Language
      if (this.Language === '1') {
        this.$root.languageData = English
      } else if (this.Language === '2') {
        this.$root.languageData = complex
      } else if (this.Language === '3') {
        this.$root.languageData = simple
      }
      // 屏幕计算
      document.getElementsByTagName('html')[0].style.fontSize = '100px'
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var s;
      (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] : 0
      this.ieNum = Sys.ie
		},

	},
  mounted () {
    console.log(window.location.href);
    if(window.location.href.indexOf('?lang=') >=1){
      console.log(this.getUrl(window.location.href,'lang'));
      if(this.getUrl(window.location.href,'lang')=='en'){
        this.sessionSetItem('Language', 1)
      }else if(this.getUrl(window.location.href,'lang')=='tc'){
        this.sessionSetItem('Language', 2)
      }else if(this.getUrl(window.location.href,'lang')=='sc'){
        this.sessionSetItem('Language', 3)
      }
    }
    if(!this.sessionGetItem('Language')){
      this.sessionSetItem('Language', 1)
    }
    this.Language = this.sessionGetItem('Language')
    this.isLanSelect = this.Language
    if (this.Language === '1') {
      this.$root.languageData = English
    } else if (this.Language === '2') {
      this.$root.languageData = complex
    } else if (this.Language === '3') {
      this.$root.languageData = simple
    }
    // 屏幕计算
    document.getElementsByTagName('html')[0].style.fontSize = '100px'
    // var width = document.getElementsByTagName('html')[0].clientWidth
    // if (width < 1200) {
    //   width = 1200
    // }
    // document.getElementsByTagName('html')[0].style.fontSize = width / 1920 * 100 + 'px'
    // window.onresize = () => {
    //   var width = document.getElementsByTagName('html')[0].clientWidth
    //   if (width < 1200) {
    //     width = 1200
    //   }
    //   document.getElementsByTagName('html')[0].style.fontSize = width / 1920 * 100 + 'px'
    // }

    this.$nextTick(() => {
      //window.addEventListener('resize', this.onResize);
    })
    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }

    var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] : 0
    this.ieNum = Sys.ie
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  beforeUpdate () {
    // 是否有標題
    this.titleChange()
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#sizeSelect{
  height: 0.32rem;
  margin: 0;
  padding: 0;
  position: relative;
  bottom: -36%;
  right: -41%;
}
.common-style{
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 0;
  display: inline-block;
  text-align: center;
}
.smallFont {
  width: 20px;
  height: 20px;
  font-size: 0.16rem;
}
.midFont {
  width: 24px;
  height: 25px;
  font-size: 0.20rem;
}
.bigFont {
  width: 30px;
  height: 30px;
  font-size: 0.25rem;
}
.font-style {
  // text-decoration: underline
  // background-color: #61126b;
  color: #61126b;
  font-weight: bold;
  border: 1px solid #61126b;
}
.lan-style{
  color: #61126b;
  font-weight: bold;
}
// 版本號樣式
.version{
  position: absolute;
  top: 0.9rem;
  right: 0.32rem;
}
.aClass {
  text-decoration:none;
  color: black;
}

a.aClass:link{
      color: black;
  }

@media (max-width: 767px) {
  .maximg {
    width: 88% !important;
  }

  .menuIcon{
    width: 40px;
  }
  .fs {
    font-size: .24rem !important;
  }
  .navbar-toggle {
  position: fixed!important;
  right: 0;
  top: .2rem;
  z-index: 999;
  background-color: #fff;
  border: none;
  }
  .longlong {
    height: 15rem;
    background-color: #fff;
    position: fixed;
    z-index: 999;
    width: 100%;
 }
 #top-nav {
   transition: none;
   border: none;
   background-color: #fff;
   box-shadow: none;
   border-bottom: none !important;
 }
}
.vrvr {
  display: block !important;
}

@media (max-width: 767px) {
  .menuIconButton{
    border: none;
    background: transparent;
    display: block !important;
  }

}

  @media (min-width:1215px)  {

  .mainContentContainer{
      min-width: 1214px;
    }
  }

  @media (min-width:1024px) and (max-width:1214px) {
    .mainContentContainer{
      min-width: 1024px;
    }
  }

  @media (min-width:768px) and (max-width:1023px) {
    .mainContentContainer{
      min-width: 768px;
    }
  }



.menuIconButton{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue